<template>
  <div class="home" style="position: relative; z-index: 1">
    <transition name="fade" mode="out-in">
        <simple-map v-if="checklistId === 0" :tree="tree" :selected-id="selectedPositionId" @openSteps="openSteps(...arguments)" @select="selectPosition(...arguments)" />
        <checklist v-else
          :title="checklistTitle"
          :description="checklistDescription"
          :list="checklists[checklistId]" @close="checklistId = 0" />
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import SimpleMap from '@/components/SimpleMap.vue'
import Checklist from '@/components/Checklist.vue'

const prerequisites = {
  '0': [
    {
      title: 'Demonstrated Critical Thinking',
      body: '<p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>',
      state: 'done',
      opened: false
    },
    {
      title: 'Demonstrated Collaboration',
      body: '<p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>',
      state: 'done',
      opened: false
    },
    {
      title: 'Agile Certification',
      body: '<p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>',
      state: 'next',
      opened: true
    },
    {
      title: 'Northwest Conference',
      body: '<p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>',
      state: 'todo',
      opened: false
    },
    {
      title: 'Leadership Webinar',
      body: '<p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>',
      state: 'todo',
      opened: false
    }
  ],
  '1': [],
  '2': [
    {
      title: 'Certification: CSM',
      body: '<p>Cras mattis consectetur purus sit amet fermentum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Sed posuere consectetur est at lobortis.</p>',
      state: 'done',
      opened: false
    },
    {
      title: 'Certification: International Certifications for C and C++',
      body: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.</p>',
      state: 'next',
      opened: false
    },
    {
      title: 'Certification: Certified Secure Software Lifecycle Professional (CSSLP)',
      body: '<p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nulla vitae elit libero, a pharetra augue. Etiam porta sem malesuada magna mollis euismod. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>',
      state: 'next',
      opened: false
    },
    {
      title: 'Course: Diversity & Inclusion',
      body: '<p>Maecenas faucibus mollis interdum. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.</p>',
      state: 'next',
      opened: false
    },
    {
      title: 'Course: Introduction to DevOps',
      body: '<p>Donec sed odio dui. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.</p>',
      state: 'todo',
      opened: false
    }
  ],
  '7': [
    {
      title: 'Course: Ethics and Code of Conduct',
      body: '<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.</p>',
      state: 'todo',
      opened: false
    },
    {
      title: 'Certification: CSM',
      body: '<p>Cras mattis consectetur purus sit amet fermentum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Sed posuere consectetur est at lobortis.</p>',
      state: 'done',
      opened: false
    },
    {
      title: 'Certification: A-CSM (Advanced Certified Scrum Master)',
      body: '<p>Must have 12 months in five years in Scum Master role. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Nullam id dolor id nibh ultricies vehicula ut id elit. Sed posuere consectetur est at lobortis.</p>',
      state: 'todo',
      opened: false
    }
  ],
  '8': [
    {
      title: 'Certification: CSM',
      body: '<p>Cras mattis consectetur purus sit amet fermentum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Sed posuere consectetur est at lobortis.</p>',
      state: 'done',
      opened: false
    },
    {
      title: 'Certification: A-CSM (Advanced Certified Scrum Master)',
      body: '<p>Must have 12 months in five years in Scum Master role. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Nullam id dolor id nibh ultricies vehicula ut id elit. Sed posuere consectetur est at lobortis.</p>',
      state: 'todo',
      opened: false
    },
    {
      title: 'Certification: CSPO (Certified Product Owner)',
      body: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras mattis consectetur purus sit amet fermentum. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Nullam quis risus eget urna mollis ornare vel eu leo. Donec ullamcorper nulla non metus auctor fringilla.</p>',
      state: 'todo',
      opened: false
    }
  ]
};

const tree = [
    {
        title: 'Developer, Tester',
        id: 1,
        children: [
            {
                title: 'Senior Developer, Scrum Master',
                id: 2,
                children: [
                    {
                        title: 'Technical Lead',
                        id: 3,
                        checklistId: '7',
                        children: [
                            {
                                title: 'Associate Architect',
                                id: 4,
                                checklistId: '8',
                                children: [
                                    {
                                        title: 'Software Architect',
                                        id: 5,
                                        checklistId: '8'
                                    }
                                ]
                            },
                            {
                                title: 'Software Technical Manager',
                                id: 6,
                                checklistId: '8'
                            }
                        ]
                    },
                    {
                        title: 'Senior Scrum Master',
                        description: 'Lorem ipsum',
                        id: 7,
                        children: [
                            {
                                title: 'Agile Technical Coach',
                                id: 8
                            },
                            {
                                title: 'Lorem Ipsum',
                                id: 78
                            }
                        ]
                    },
                    {
                        title: 'Interdum Adipiscing Elit',
                        id: 77
                    }
                ]
            },
            {
                title: 'Software Development Engineer in Test',
                id: 9,
                checklistId: '2',
                children: [
                    {
                        title: 'Test Manager',
                        id: 10,
                        checklistId: '7',
                        children: [
                            {
                                title: 'Software Quality Manager',
                                id: 11,
                                checklistId: '8'
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
export default {
  name: 'home',
  components: {
    SimpleMap,
    Checklist
  },
  data() {
    return {
      tree: tree,
      checklistId: 0,
      checklistTitle: '',
      checklistDescription: '',
      selectedPositionId: 0,
      checklists: prerequisites
    }
  },
  created() {
    for (let i = 0; i < this.tree.length; i++) {
      this.tree.splice(i, 1, this.populateChecklists(this.tree[i]));
    }
  },
  methods: {
    populateChecklists(n) {
      let checklistId = n.checklistId;
      if (checklistId === undefined) {
        checklistId = n.id;
      }
      if (this.checklists[checklistId] === undefined) {
        checklistId = '0';
      }
      n.checklist = this.checklists[checklistId];
      n.checklistId = checklistId;

      if (n.children) {
        for (let i = 0; i < n.children.length; i++) {
          n.children.splice(i, 1, this.populateChecklists(n.children[i]));
        }
      }
      return n;
    },
    selectPosition(id) {
      this.selectedPositionId = id;
    },
    openSteps(checklistId, title, description) {
      if (!checklistId || !this.checklists[checklistId]) {
        checklistId = '0';
      }
      this.checklistId = checklistId;
      this.checklistTitle = title;
      this.checklistDescription = description;
    }
  }
}
</script>
